import React from 'react';
import PropTypes from 'prop-types';
import common from '../../../common/common';
import styles from './index.module.scss';

class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false // 是否展开下拉菜单
        }
    }

    static defaultProps = {
        options: [],
        optionLabelKey: 'label',
        optionValueKey: 'value',
        displayValueKey: 'label',
        value: undefined,
        placeholder: '请选择',
        size: 'default',
        onChange: null,
    };

    static propTypes = {
        options: PropTypes.array, // 下拉列表选项
        optionLabelKey: PropTypes.string, // 下拉列表每一条需要展示的label的key，默认为'label'
        optionValueKey: PropTypes.string, // 下拉列表每一条value值的key，默认为'value'
        displayValueKey: PropTypes.string, // 选中后回填到选择框的value的key，默认为'label'
        // 当前选中的value值
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        placeholder: PropTypes.string,
        size: PropTypes.string, // 选择框大小，可选 large default small
        onChange: PropTypes.func, // 选中 option，或 input 的 value 变化时，调用此函数
    };

    componentDidMount() {
        window.addEventListener('click', this.hideDropdown, false);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.hideDropdown, false);
    }

    // 控制下拉列表展示
    onDropdownVisibleChange = (open) => {
        this.setState({
            open
        })
    };

    // 隐藏下拉列表
    hideDropdown = () => {
        this.onDropdownVisibleChange(false);
    };

    // 选中的value值改变后的回调
    onChange = (value) => {
        this.hideDropdown();

        if (value === this.props.value) return;
        typeof this.props.onChange === 'function' && this.props.onChange(value);
    };


    render() {
        const {
            options,
            optionLabelKey,
            optionValueKey,
            displayValueKey,
            value,
            placeholder,
            size,
        } = this.props;

        const { open } = this.state;

        // 回填到选择框的内容
        let displayValue = placeholder;
        const matchItem = options.find(item => item[optionValueKey] === value);
        if (value !== undefined && matchItem) displayValue = matchItem[displayValueKey];

        return (
            <div className={`${styles.select} ${styles[size]}${common.isTablet() ? ` ${styles.tablet}` : ''}`} onClick={(e) => {e.stopPropagation()}}>
                <div className={`${styles.selection} ${open ? styles.open : ''}`} onClick={() => this.onDropdownVisibleChange(!open)}>
                    <div className={styles.value}>
                        { displayValue }
                    </div>
                    <span className={styles.iconArrow}/>
                </div>
                {/*下拉列表 start*/}
                <ul className={`${styles.dropDownMenu} ${open ? '' : 'hide'} light-scroll-bar`}>
                    {
                        options.map(item =>
                            <li className={item[optionValueKey] === value ? styles.active: ''} key={item[optionValueKey]} onClick={() => this.onChange(item[optionValueKey])}>{item[optionLabelKey] || ''}</li>
                        )
                    }
                </ul>
                {/*下拉列表 end*/}
            </div>
        )
    }
}
export default Select;